import { render } from "./optionbutton.vue?vue&type=template&id=1ab9d80a"
import script from "./optionbutton.vue?vue&type=script&lang=js"
export * from "./optionbutton.vue?vue&type=script&lang=js"

import "./optionbutton.vue?vue&type=style&index=0&id=1ab9d80a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__